import { render, staticRenderFns } from "./OpenTicket.vue?vue&type=template&id=ff0e2e4c&"
import script from "./OpenTicket.vue?vue&type=script&lang=js&"
export * from "./OpenTicket.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports